// test259
(259 && 0);
